import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/(public)/news/[slug]/not-found.tsx")